<template lang="pug">
button.header-button
  .header-button__prepend(v-if="hasPrepend")
    slot(name="prepend")
  .header-button__content
    .header-button__subtitle(v-if="hasSubtitle && subtitleTop")
      slot(name="subtitle") {{ subtitle }}
    .header-button__label
      slot {{ label }}
    .header-button__subtitle(v-if="hasSubtitle && !subtitleTop")
      slot(name="subtitle") {{ subtitle }}
  .header-button__append(v-if="hasAppend")
    slot(name="append")
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      defalt: null,
    },
    subtitle: {
      type: String,
      defalt: null,
    },
    subtitleTop: {
      type: Boolean,
      defalt: false,
    },
  },

  computed: {
    hasSubtitle() {
      return !!this.$slots.subtitle || this.subtitle;
    },

    hasPrepend() {
      return !!this.$slots.prepend;
    },

    hasAppend() {
      return !!this.$slots.append;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/stylesheet/_variables.scss";

.header-button {
  background: $white;
  height: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  border: 1px solid $bb-gray-900;
  border-top: 0;
  border-bottom: 0;
  padding: 0 20px;
  color: inherit;
  font-size: 16px;
  white-space: nowrap;
  text-align: left;
  transition: all $bb-duration ease-in-out;

  & + & {
    margin-left: -1px;
  }

  &:focus {
    outline: none;
  }

  &.active,
  &.router-link-active {
    background: mix($bb-gray-900, $white, 50%);
  }

  &__prepend {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
  }

  &__append {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
  }

  &__icon {
    font-size: 24px;
    max-width: 24px;
    display: block;
    color: $bb-gray-700;
  }

  &__subtitle {
    color: $bb-gray-600;
    font-size: 11px;
    transition: all $bb-duration ease-in-out;
  }

  @at-root {
    button#{&}:not([disabled]):hover,
    a#{&}[href]:hover {
      position: relative;
      z-index: 1;
      cursor: pointer;
      background-color: mix($primary, $white, 10%);
      border-color: mix($primary, $white, 10%);
      text-decoration: none;
      color: inherit;
    }

    button#{&}:not([disabled]):hover &__subtitle,
    a#{&}[href]:hover &__subtitle {
      color: mix($primary, $white, 80%);
    }
  }

  &.header-nav-item {
    font-size: 14px;
    padding: 0 15px;
    border: none;
  }

  &.header-nav-item &__prepend {
    margin-right: 10px;
  }

  &.header-nav-item.active,
  &.header-nav-item.router-link-active {
    background: mix($primary, $white, 10%);
    color: $primary;
  }

  &.header-nav-item.active &__icon,
  &.header-nav-item.router-link-active &__icon {
    color: mix($primary, $white, 70%);
  }
}
</style>
